import { render } from "./InsightCard.vue?vue&type=template&id=f950396c"
import script from "./InsightCard.vue?vue&type=script&lang=js"
export * from "./InsightCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/cb-payments-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__